import { render } from "./NotificationSurveyItemsListView.vue?vue&type=template&id=611d14b4&scoped=true&ts=true"
import script from "./NotificationSurveyItemsListView.vue?vue&type=script&lang=ts"
export * from "./NotificationSurveyItemsListView.vue?vue&type=script&lang=ts"

import "./NotificationSurveyItemsListView.vue?vue&type=style&index=0&id=611d14b4&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611d14b4"]])

export default __exports__